export default {
  'menu.system': 'مدیریت سیستم',
  'menu.system.user': 'مدیریت کاربران',
  'menu.system.role': 'مدیریت نقش‌ها',
  'menu.system.menu': 'مدیریت منوها',
  'menu.system.dept': 'مدیریت بخش‌ها',
  'menu.monitor': 'نظارت',
  'menu.monitor.login-log': 'لاگین',
  'menu.monitor.oper-log': 'عملیات',
  'menu.login': 'ورود',
};
